module.exports = __webpack_public_path__ + "static/media/applaud-icon.aaf0601b.svg";